<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="CONTA_CONTABIL"
          label="Conta contábil"
          class="required rounded-tag-small"
          v-model="formData.contaContabil"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="ARMAZEM"
          label="Depósito"
          class="required rounded-tag-small"
          v-model="formData.armazem"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
